import { render, staticRenderFns } from "./newsletter.vue?vue&type=template&id=05e9cf8d&"
import script from "./newsletter.vue?vue&type=script&lang=js&"
export * from "./newsletter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports